import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useGreetings = () => {
  return useQuery(
    ["greetings"],
    async () => {
      const { data } = await axiosPost("/api/cw/greeting", {});
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGreetings;
